import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import API from "../Context/api";

function VerifyEmail() {
  const { token } = useParams();
  const navigate = useNavigate();

  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // "success" or "error"
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        await API.get(`/auth/verify-email/${token}`);
        setMessage("Email verified successfully! Redirecting to login...");
        setMessageType("success");
        setTimeout(() => {
          navigate("/login");
        }, 1000); // Redirect after 2 seconds
      } catch (error) {
        setMessage(
          error.response?.data?.message ||
            "Network error or server not responding. Please try again."
        );
        setMessageType("error");
        setLoading(false);
      }
    };

    verifyEmail();
  }, [token, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-6 bg-white p-8 rounded-xl shadow-lg">
        {/* Feedback Message */}
        {messageType && message && (
          <div
            className={`text-center text-sm p-3 rounded-md ${
              messageType === "success"
                ? "bg-green-100 text-green-700"
                : "bg-red-100 text-red-700"
            }`}
          >
            {message}
          </div>
        )}

        {/* Loading State */}
        {loading && messageType !== "error" && (
          <p className="text-center text-gray-600 text-base">
            Verifying your email address. Please wait...
          </p>
        )}
      </div>
    </div>
  );
}

export default VerifyEmail;
